import React from "react";
import "../Assests/Scss/ReviewSubmit.scss";
import { FaAngleDoubleRight, FaAngleDoubleLeft } from "react-icons/fa";
import {
  AsessmentReviewMsgEnglish,
  AsessmentReviewMsgHindi,
} from "../Reusablecomponents/CustomizedStaticTranslations";
import { CheckLanguage } from "../../ReusableComponents/CommonFunctions";
import { useSelector } from "react-redux";

const ReviewSubmit = (props) => {
  // const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const ConformModelOpen = () => {
    if (navigator.onLine) {
      localStorage.removeItem("ResumeId");
      props.ModelCLose(false);
      props.ConformModelCLose(true);
      props.Relatedtext(true);
    }
  };
  const SLanguage = CheckLanguage(items?.mediumId)
    ? AsessmentReviewMsgHindi(
        props.answered,
        props.TotalQuestions,
        props.remaningtime,
        props.subjectname
      )
    : AsessmentReviewMsgEnglish(
        props.answered,
        props.TotalQuestions,
        props.remaningtime,
        props.subjectname
      );
  return (
    <>
      <div className="Model-Maindiv">
        <div className="Model-Main dflex flexd-column alignitems">
          <p>{SLanguage?.[4]}</p>
          <hr style={{ width: "100%", color: "#298F9E" }} />
          <div className="Details-ANswers">{SLanguage?.[0]}</div>

          <div className="Model-buttons alignitems dflex">
            <button
              className="Buttons"
              onClick={() => {
                props.ModelCLose(false);
              }}
            >
              {" "}
              <FaAngleDoubleLeft /> {SLanguage?.[1]}{" "}
            </button>
            <button className="Buttons" onClick={ConformModelOpen}>
              <div className="dflex flexd-column">
                {" "}
                {SLanguage?.[2]}
                <span>( {SLanguage?.[3]})</span>
              </div>{" "}
              <FaAngleDoubleRight />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReviewSubmit;
